import * as React from 'react';
import { CardHeader, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Skeleton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  title: {
    wordBreak: 'break-word',
  },
  actions: {
    marginLeft: 'auto',
  },
}));

interface Props {
  loading: boolean;
  title: string;
  onEditClick: () => void;
}

const CardTitle: React.FC<Props> = ({ loading, title, onEditClick }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const editButton = (
    <IconButton
      className={classes.actions}
      title={t('edit')}
      color="secondary"
      onClick={onEditClick}
      size="large">
      <EditIcon />
    </IconButton>
  );
  return (
    <CardHeader
      classes={{ title: classes.title }}
      action={loading ? <Skeleton>{editButton}</Skeleton> : editButton}
      title={
        loading ? (
          <Skeleton>
            <span>{title}</span>
          </Skeleton>
        ) : (
          title
        )
      }
    />
  );
};

export default CardTitle;
